import { Box, Typography } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import useStyles from './styles';
interface IModalProps {
  open: boolean;
  handleClose: () => void;
  handlecancel: () => void;
  handleBack: () => void;
}
const Modal = (props: IModalProps) => {
  const classes = useStyles();
  return (
    <>
      <Dialog
        open={props.open}
        onClose={props.handleClose}
        aria-labelledby=""
        classes={{ paper: classes.dialogPaper }}
      >
        <Typography className={classes.title}>
          Deseja cancelar sua solicitação de compra?
        </Typography>
        <Typography>Esta ação não poderá ser revertida.</Typography>
        <Box
          display="flex"
          justifyContent="center"
          alignItems="flex-end"
          flexDirection="column"
          marginTop='25px'
        >
          <Button
            variant="contained"
            onClick={props.handleBack}
            className={classes.button}
          >
            Não, voltar!
          </Button>

          <Button
            variant="outlined"
            onClick={props.handlecancel}
            className={classes.button}
          >
            Sim, eu quero cancelar.
          </Button>
        </Box>
      </Dialog>
    </>
  );
};
export default Modal;
